// src/services/api/activityTypes.service.ts

import { apiClient, makeApiRequest } from './client';
import { endpoints } from './config';
import { ActivityType, ActivityTypeCreate, ActivityTypeUpdate } from './types';

export class ActivityTypesService {
  async getProjectActivityTypes(projectId: number): Promise<ActivityType[]> {
    return makeApiRequest(() =>
      apiClient.get<ActivityType[]>(endpoints.activityTypes.byProject(projectId))
    );
  }

  async createActivityType(data: ActivityTypeCreate): Promise<ActivityType> {
    return makeApiRequest(() =>
      apiClient.post<ActivityType>(endpoints.activityTypes.create, data)
    );
  }

  async updateActivityType(id: number, data: ActivityTypeUpdate): Promise<ActivityType> {
    return makeApiRequest(() =>
      apiClient.put<ActivityType>(endpoints.activityTypes.update(id), data)
    );
  }

  async deleteActivityType(id: number): Promise<void> {
    return makeApiRequest(() =>
      apiClient.delete(endpoints.activityTypes.delete(id))
    );
  }
}

export const activityTypesService = new ActivityTypesService();
